import qs from "query-string";

export default function ParseURL(url: string): string {
  const query = qs.parse(location.search) as any;
  if (url.indexOf("hotelId=") == -1) {
    if (url.indexOf("?") == -1) {
      url = url + "?";
    }
    url = url + "hotelId=" + query.hotelId;
  }
  if (url.indexOf("outletId=") == -1) {
    url = url + "&outletId=" + query.outletId;
  }
  return url;
}
